import { render } from "./ChannelListPage.vue?vue&type=template&id=55b7de6e&ts=true"
import script from "./ChannelListPage.vue?vue&type=script&lang=ts"
export * from "./ChannelListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__